import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { InitializeNewsletterSendingRequest } from './initialize-newsletter-sending.request';

@Injectable({ providedIn: 'root' })
export class InitializeNewsletterSendingUseCase extends UseCase<InitializeNewsletterSendingRequest, Observable<HttpResponse<any>>> {
    private _apiRequestService = inject(ApiRequestService);
    private _emailBaseUrl = inject<string>('EMAIL_BACKEND_URL' as any);
    private _initializeNewsletterSendingUrl = '/admin/initializeNewsletterSending';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(
        request: InitializeNewsletterSendingRequest | void
    ): Observable<HttpResponse<any>> | void {
        return this._apiRequestService.sendRequest<InitializeNewsletterSendingRequest, HttpResponse<any>>(
            this._emailBaseUrl,
            request as InitializeNewsletterSendingRequest,
            true,
            this._initializeNewsletterSendingUrl
        );
    }
}
